import React, { useEffect } from 'react'
import { Accordions } from '../../components/accordion/Accordions'
import { postresData } from '../../data/carta/postres.js'
import { MenuDropdown } from '../../components/menu/MenuDropdown';

export const Postres = () => {
    const lang = localStorage.getItem('lang') || 'es';

    const data = {
        es: {
            title: 'Postres - Karnivoro Restaurant',
        },
        en: {
            title: 'Desserts - Karnivoro Restaurant',
        }
    }

    document.title = data.es.title;
    useEffect(() => {
        window.location.href = "https://app.okeymenu.com/lSmSoq/es";
      }, []);
  return (
    <div>
        <div className='text-center'>  
            <MenuDropdown />   
        </div>
        {/* <div className='mt-4'>
            <h1 className='text-center text-uppercase'><b>{data.es.title}</b></h1>
        </div> */}
        <div className='mt-4'> 
            <Accordions data={postresData} lang={lang} />
        </div>
    </div>
  )
}
